export interface AppModalDisplayOptions {
  showCtas?: boolean;
  showRating?: boolean;
  showHeader?: boolean;
  showReviews?: boolean;
  skin?: 'lean' | 'slim' | 'normal';
  showPermissions?: boolean;
  showPricingPlans?: boolean;
  showStickyHeader?: boolean;
  showModalLayout?: boolean;
  showTermsAndConditions?: boolean;
  showAppPageLink?: boolean;
}

export enum AppPageType {
  FULL_PAGE = 'FULL_PAGE',
  ONE_STEP_SLIM = 'ONE_STEP_SLIM',
  ONE_STEP_RICH = 'ONE_STEP_RICH',
}
